import { app, authentication } from '@microsoft/teams-js';

let _initialized: boolean | null = null;
let _initPromise: Promise<void> | null = null;

function initialize(): Promise<void> {
  if (!_initPromise) {
    _initPromise = app.initialize().then(
      () => { _initialized = true; },
      () => { _initialized = false; },
    );
  }
  return _initPromise;
}

export async function isInTeams(): Promise<boolean> {
  await initialize();
  return _initialized === true;
}

export async function getTeamsAuthToken(): Promise<string | null> {
  if (!(await isInTeams())) return null;
  try {
    return await authentication.getAuthToken();
  } catch {
    return null;
  }
}

export async function authenticateViaPopup(): Promise<boolean> {
  if (!(await isInTeams())) return false;
  try {
    await authentication.authenticate({
      url: `${window.location.origin}/.auth/login/aad?post_login_redirect_uri=/teams-auth-end.html`,
      width: 500,
      height: 600,
    });
    return true;
  } catch {
    return false;
  }
}
